

const rawApiBaseUrl = process.env.REACT_APP_API_URL;

if (!rawApiBaseUrl) {
  throw new Error("Missing REACT_APP_API_URL. Set it in your build environment.");
}

export const API_BASE_URL = rawApiBaseUrl.replace(/\/$/, "");

export const buildApiUrl = (path = "") =>
  `${API_BASE_URL}/${String(path).replace(/^\/+/, "")}`;
